import React from 'react';

import Utils from 'files/Utils.js';

const FamilyBanner = () => {

    const isMobile = Utils.isMobile();

    return (
        <section style={{
            position: 'relative',
            width: '100%'
        }}>
            <div style={{
                background: `linear-gradient(to bottom, #F5F6FA, rgba(245,246,250,0.8) 40%, rgba(245,246,250,0))`,
                height: isMobile ? 112 : 144,
                left: 0,
                position: 'absolute',
                right: 0,
                top: 0,
                zIndex: 10
            }} />
            <div style={{
                height: isMobile ? 500 : 700,
                position: 'relative',
                width: '100%'
            }}>
                <img
                alt={'Happy family feeling safe and protected in their home'}
                src={require('assets/family-protected-home.jpg')}
                style={{
                    height: '100%',
                    objectFit: 'cover',
                    width: '100%'
                }} />
                <div style={{
                    background: 'linear-gradient(to top, rgba(0,0,0,0.6), rgba(0,0,0,0))',
                    bottom: 0,
                    left: 0,
                    position: 'absolute',
                    right: 0,
                    top: 0
                }} />
                <div style={{
                    bottom: 32,
                    left: 0,
                    position: 'absolute',
                    right: 0,
                    textAlign: 'center'
                }}>
                    <h2 style={{
                        color: '#FFFFFF',
                        fontFamily: '"Poppins", sans-serif',
                        fontSize: isMobile ? 32 : 48,
                        fontWeight: 700,
                        margin: '0 16px',
                        textShadow: '0 4px 8px rgba(0,0,0,0.5)'
                    }}>{'The Safety Network Your Home Deserves'}</h2>
                </div>
            </div>
        </section>
    )
}

export default FamilyBanner;
